var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 336,
    viewBox: "0 0 224 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2125_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.854 1H12.1464C5.99043 1 1 6.35654 1 12.9642V323.036C1 329.643 5.99043 335 12.1464 335H211.854C218.01 335 223 329.643 223 323.036V12.9642C223 6.35654 218.01 1 211.854 1Z",
    fill: "white",
    stroke: "#0B0B0B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2125_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1893 37C19.6893 37 37.1893 19 37.1893 17C37.1893 19 54.6893 37 57.1893 37C54.6893 37 37.1893 55 37.1893 57C37.1893 55 19.6893 37 17.1893 37Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2125_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.2 135.027C115.206 136.121 115.206 136.121 115.213 137.237C115.255 144.111 115.301 150.984 115.353 157.858C115.38 161.392 115.405 164.925 115.425 168.459C115.445 171.87 115.469 175.28 115.498 178.691C115.508 179.992 115.516 181.293 115.522 182.594C115.531 184.416 115.546 186.239 115.563 188.062C115.57 189.099 115.577 190.136 115.585 191.205C115.73 193.806 115.906 195.309 116.8 197.434C118.422 198.586 118.422 198.586 120 199.217C120 199.805 120 200.394 120 201C114.896 201 109.792 201 104.533 201C104.533 200.412 104.533 199.823 104.533 199.217C106.909 198.334 106.909 198.334 109.333 197.434C109.358 190.854 109.377 184.275 109.389 177.695C109.394 174.64 109.402 171.585 109.414 168.53C109.428 165.018 109.433 161.506 109.438 157.994C109.443 156.896 109.449 155.799 109.454 154.668C109.454 153.142 109.454 153.142 109.454 151.585C109.457 150.688 109.459 149.792 109.462 148.868C109.428 146.397 109.428 146.397 108.267 143.942C107.035 144.236 105.803 144.531 104.533 144.834C104.357 143.951 104.181 143.068 104 142.159C105.364 140.959 106.73 139.773 108.1 138.593C108.485 138.253 108.869 137.913 109.266 137.562C109.642 137.24 110.018 136.919 110.406 136.587C110.75 136.288 111.093 135.989 111.447 135.682C112.747 134.898 113.827 134.982 115.2 135.027Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2125_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.189 299C168.689 299 186.189 281 186.189 279C186.189 281 203.689 299 206.189 299C203.689 299 186.189 317 186.189 319C186.189 317 168.689 299 166.189 299Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2125_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 336,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2125_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "translate(17 17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2125_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 70,
    fill: "white",
    transform: "matrix(-1 0 0 -1 122 203)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2125_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "translate(166 279)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1D);
export default __webpack_public_path__ + "static/media/1D.fcbaf49ab899d312269de4e27aacd8c1.svg";
export { ForwardRef as ReactComponent };